module.exports = __webpack_public_path__ + "media/images/guy_floating-f3b5536cf534e8b44978da57988066af.png";